import { Component } from '@angular/core';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountService } from '../../singelton/account.service';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import {Observable} from "rxjs";
import {SERVER_API_URL} from "../../app.constants";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {IDoctor} from "../model/doctor.model";
import {Impersonate} from "../model/Impersonate.model";
import {map} from "rxjs/operators";


@Component({
  selector: 'impersonate.popup.component',
  templateUrl: './impersonate.popup.component.html'
})
export class ImpersonatePopupComponent {

  impersonateForm: FormGroup;
  public userName: AbstractControl;

  constructor(protected activatedRoute: ActivatedRoute,
              private fb: FormBuilder,
              public activeModal: NgbActiveModal,
              private toastr: ToastrService,
              private http: HttpClient,
              private accountService: AccountService,
              private spinner: NgxSpinnerService,
) {

    this.impersonateForm = this.fb.group({
      'userName': ['', Validators.compose([Validators.required])],
    });

    this.userName = this.impersonateForm.controls['userName'];

  }


  private onError(error) {
    // this.alertService.error(error.error, error.message, null);
  }



  clear_cancel() {
    this.activeModal.dismiss('cancel22');
  }

  clear() {
    this.activeModal.dismiss('save');
  }


  save(): void {
    this.spinner.show();
       this.http.post<Impersonate>(SERVER_API_URL + 'api/authenticate-impersonate', {}, {params:{'userName': this.userName.value}})
         .pipe(map((res: Impersonate) => {return  res}))
          .subscribe( (res: Impersonate) =>{
         //   alert(JSON.stringify(res.id_token))
           localStorage.setItem('authenticationToken', (res.id_token));
           sessionStorage.setItem('authenticationToken', (res.id_token));
         //  localStorage.setItem('isImpersonated', 'true');
           this.spinner.hide();
           window.location.reload()
           },
           (reject)=>{
             this.spinner.hide();
             // check api error code
             if(reject.status == 404)
               this.toastr.error("کاربر یافت نشد","خطا");
              else
                this.toastr.error("خطا در جعل کاربر","خطا")});
  }
}
